<template>
    <div>
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="que-mod">
            <table class="que-table" v-infinite-scroll="_loadMore" infinite-scroll-disabled="loading" infinite-scroll-immediate-check="false">
                <thead>
                    <tr>
                        <th>Quest နံပါတ္</th><th>ရောက်ရှိအခြေနေများ</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list">
                        <td>{{item.code}}</td><td><div @click="_startQa(index)" :class="{'btn':true,'btn-sm':true,'btn-blue':item.status==1,'btn-yell':item.status==0, 'btn-gray':item.status==2}">{{item.status_text}}</div></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <!-- <question></question> -->
    </div>
</template>

<script>
import answerHeader from './Header'
import question from './Question'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Store',
    components: {answerHeader, question},
    data(){
        return {
            page: 0,
            loading: false,
            list: []
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        this._loadMore();
    },
    filters: {
        statusConvert(status){
            return ''
        }
    },
    methods: {
        _loadMore(){
            // if(this.loading) return;
            this.loading = true;
            this._fetchList().done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                }
                else if(res.data.list.length > 0){
                    this.list = this.list.concat(res.data.list);
                }else{
                    this.$toast('no data');
                }
            }).always(()=>{
                this.loading = false;
            })
        },
        _fetchList(){
            this.page++;
            return Utils.$ajax({
                url: '/user/list&page_size=6&page_id='+this.page
            })
        },
        _startQa(index){
            var item = this.list[index];
            if(item.status == 0){
                this.$router.push(`/end?id=${item.id}`);
            }else{
                this.$router.push(`/answer?id=${item.id}`);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .que-mod{
        width: 100%;
        height: rem(650);
        margin-bottom: rem(40);
        overflow: scroll;
    }
    .que-table{
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: rem(30);
        td, th{
            border-bottom: 1px rgba(255,255,255,.6) dashed;
            padding: .8em 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Store.vue